export const GameMenuItem: React.FC<{
  children: string;
  onClick: () => void;
}> = ({ children, onClick }) => {
  return (
    <button
      className="transition-colors title title-xl hover:text-accent focus-visible:outline-none focus-visible:ring"
      onClick={onClick}
    >
      {children}
    </button>
  );
};
